import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, DataTable, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';
import { ContactDetailSkeleton } from '../../nastaveni/kontaktni-udaje/Skeletons';

export const ProfileROSDetailSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);

	return (
		<LayoutGap gap="m">
			<ContentLayout>
				<DataTable
					noStripped
					responsive>
					<tbody>
						{Array.from({ length: 10 }).map((_, i) => (
							// eslint-disable-next-line react/no-array-index-key
							<tr key={i}>
								<td className="sm:w-1/2">
									<GovSkeleton
										width={generateRandomNumber(20, 60) + '%'}
										height="18px"
										aria-label={t('loading.wcag.processing', {
											namespace: LocalizeNameSpaceTypes.Global,
										})}
									/>
								</td>
								<td className="sm:w-1/2">
									<GovSkeleton
										width={generateRandomNumber(20, 60) + '%'}
										height="18px"
										aria-label={t('loading.wcag.processing', {
											namespace: LocalizeNameSpaceTypes.Global,
										})}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</DataTable>
				<div className="flex justify-end">
					<GovSkeleton
						width="220px"
						height="40px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</ContentLayout>
			<ContentLayout>
				<ContactDetailSkeleton />
				<ContactDetailSkeleton />
			</ContentLayout>
		</LayoutGap>
	);
};
